import React, { useEffect, useState } from 'react'
import './ImagePreviewWrapper.css'

export enum ImagePreviewWrapperSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

interface IImagePreviewWrapperProps {
  archived?: boolean
  image: string | null
  imgPreview?: string | null
  size?: ImagePreviewWrapperSizeEnum
  onClick: () => void
  isReportPageItem?: boolean
  className?: string
}

function checkIfImageExists(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
    img.src = url
  })
}

export const ImagePreviewWrapper: React.FC<IImagePreviewWrapperProps> =
  React.memo(
    ({
      archived,
      image,
      imgPreview,
      size,
      onClick,
      isReportPageItem,
      className,
    }) => {
      const [isBroken, setIsBroken] = useState(false)
      useEffect(() => {
        let isMounted = true

        if (!image) {
          setIsBroken(true)
          return
        }

        checkIfImageExists(image)
          .then((exists) => {
            if (isMounted) setIsBroken(!exists)
          })
          .catch(() => {
            if (isMounted) setIsBroken(true)
          })

        return () => {
          isMounted = false
        }
      }, [image])

      const previewClass = `image-preview-${size?.toLowerCase() || 'medium'}`
      const containerClassName = [
        'photo-preview-block',
        className,
        archived ? 'delete-item' : '',
      ]
        .filter(Boolean)
        .join(' ')

      const onReportPageImageClick = isReportPageItem ? onClick : undefined

      return (
        <div className={`${containerClassName} ${previewClass}`}>
          {!!image && !isBroken ? (
            <>
              <img
                className={` ${previewClass}`}
                src={imgPreview ?? image}
                loading="lazy"
                alt=""
              />
              <div className="loupe-block" onClick={onClick}>
                <i className="an-ico an-ico-search" />
              </div>
            </>
          ) : (
            <div
              className={`photo-cover ${previewClass}`}
              onClick={onReportPageImageClick}
            >
              <div className="photo-cover-circle">
                <i
                  className={`an-ico an-ico-${
                    isBroken ? 'photo-error' : 'photo-add'
                  }`}
                />
              </div>
            </div>
          )}
        </div>
      )
    },
  )
